import request from '@/utils/request'

// 查询自己的上架模组列表
export function findAgentsModuleProducts(params) {
  return request({
    url: `/customer/agents_module_products`,
    method: 'get',
    params
  })
}
